<template>
  <section class="banner">
    <figure>
      <img
        alt="banner"
        src="../assets/img/banner.png"
        loading="lazy"
        @load="handdleloadImage"
      />
      <video autoplay muted loop @loadeddata="handdleload">
        <source src="../assets/img/banner.mp4" type="video/mp4" />
      </video>
    </figure>
    <ul class="banner__list">
      <li>
        <p>Apresentado por:</p>
        <a href="https://jbs.com.br/" target="_blank">
          <img src="../assets/img/logo_jbs_white.svg" alt="" />
        </a>
      </li>
      <li>
        <p>Produção:</p>
        <a href="http://bluestudio.estadao.com.br/" target="_blank">
          <img src="../assets/img/logo_bluestudio-white.svg" alt="" />
        </a>
      </li>
      <li>
        <p>Realização:</p>
        <a href="https://www.estadao.com.br/" target="_blank">
          <img src="../assets/img/logo_estadão_white.svg" alt="" />
        </a>
      </li>
    </ul>
    <div class="banner__text">
      <img
        alt="70 anos alimentando o que alimenta o mundo."
        src="../assets/img/70.svg"
        class="banner__text__titulo"
      />
      <div class="banner__text__button">
        <a href="#nossahistoria">Conheça a nossa história</a>
      </div>
    </div>
    <div class="banner__video" @click.prevent="videoModal = !videoModal">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="95"
        height="99"
        viewBox="0 0 95 99"
        fill="none"
      >
        <g clip-path="url(#clip0_152_330)">
          <path
            d="M35.6071 70.9448C35.036 70.9448 34.4648 70.8013 33.9398 70.5085C32.8956 69.9287 32.2783 68.8896 32.2783 67.73V31.4424C32.2783 30.2828 32.9014 29.2437 33.9398 28.6639C34.984 28.084 36.2244 28.084 37.2686 28.6639L69.841 46.8105C70.8852 47.3903 71.5025 48.4294 71.5025 49.5891C71.5025 50.7487 70.8795 51.7878 69.841 52.3676L37.2686 70.5143C36.7494 70.807 36.1782 70.9506 35.6071 70.9506V70.9448Z"
            fill="#FD2845"
          />
        </g>
        <defs>
          <clipPath id="clip0_152_330">
            <rect width="95" height="99" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span></span>
    </div>
    <Transition>
      <div
        :class="['banner__video__modal', videoModal ? 'active' : '']"
        v-if="videoModal"
      >
        <div class="closemodal" @click.prevent="videoModal = !videoModal"></div>
        <button @click.prevent="videoModal = !videoModal">Fechar</button>
        <div class="container">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/dymsqpTwg8s?si=oNQUKvB48DPY5Qyy"
            title="JBS comemora 70 anos"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </Transition>
  </section>
</template>

<script>
import { defineComponent, ref } from 'vue';
export default defineComponent({
  data() {
    return {
      videoModal: false,
      imagensLoad: 0,
    };
  },
  methods: {
    handdleload() {
      this.imagensLoad++;
      if (this.imagensLoad == 2) {
        setTimeout(() => {
          this.$store.commit('TOGGLE_LOADING', false);
        }, 1000);
      }
    },
    handdleloadImage() {
      this.imagensLoad++;
      if (this.imagensLoad == 2) {
        setTimeout(() => {
          this.$store.commit('TOGGLE_LOADING', false);
        }, 1000);
      }
    },
  },
});
</script>

<style scoped lang="scss">
.banner {
  position: relative;
  z-index: 200;
  padding-top: 44px;
  figure {
    video {
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
  &__video {
    position: absolute;
    right: 300px;
    top: 150px;
    cursor: pointer;
    @include media('<=desktop') {
      top: initial;
      bottom: 50px;
      right: 30px;
    }

    &__modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      opacity: 0;
      z-index: -1;
      visibility: hidden;
      transition: visibility 0.3s linear, opacity 0.3s linear;
      &.active {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }

      .closemodal {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: -1;
      }
      .container {
        position: relative;
        width: 100%;
        overflow: hidden;
        max-width: 900px;
      }
      iframe {
        width: 900px;
        height: 500px;
        @include media('<=desktop') {
          width: 350px;
          height: 250px;
          margin: 0 auto;
          display: block;
        }
      }

      button {
        background: none;
        border: none;
        color: color(cWhite);
        font-family: font(primary);
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 700;
        line-height: 135%; /* 0.84375rem */
        text-transform: uppercase;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        position: absolute;
        right: 55px;
        top: 80px;

        &:hover {
          color: color(cBlue);
        }

        &::before {
          content: '\e902';
          font-family: 'icomoon' !important;
          display: block;
          text-align: left;
          margin-block: 0.5rem;
          font-size: 0.8rem;
        }
      }
    }
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    span {
      width: 95px;
      height: 95px;
      background: url('../assets/img/text.png') center center no-repeat;
      background-size: cover;
      animation: rotateText 15s linear infinite;
      display: block;
    }
    .rotate {
      animation: rotateText 8s linear infinite;
    }
  }
  &__text {
    position: absolute;
    left: 0;
    top: 300px;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex-wrap: wrap;
    @include media('<=desktop') {
      top: 200px;
    }
    &__button {
      width: 100%;
      a {
        width: 16.25rem;
        height: 3.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: font(primary);
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: color(cWhite);
        background: color(secondary);
        margin: 4rem auto 0;
        border-radius: 5.3125rem;
        text-decoration: none;
        transition: 0.3s ease-in-out;
        position: relative;
        strong {
          font-weight: 800;
        }

        &::after {
          content: '\e900';
          font-family: 'icomoon' !important;
          position: absolute;
          top: 95%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 5rem;
          color: color(cBlue);
        }
        &:hover {
          background: color(cRed);
        }
      }
    }
    &__titulo {
      margin: 0 auto;
      @include media('<=desktop') {
        max-width: 300px;
      }
    }
  }
  &__list {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    list-style: none;
    display: flex;
    justify-content: center;
    gap: 3.2rem;
    p {
      color: color(cWhite);
      font-family: font(secondary);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 1rem;
    }

    a {
      display: block;
      text-align: center;
    }
  }
}

@keyframes rotateText {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
